export function splitAddressLabel(label: string): { street: string; cityStateZip: string } {
    const commaIndex = label.indexOf(',')
    if (commaIndex === -1) {
        return { street: label, cityStateZip: '' }
    }
    return {
        street: label.slice(0, commaIndex).trim(),
        cityStateZip: label.slice(commaIndex + 1).trim(),
    }
}
